module.exports = "/assets/data/03d0fc57d3f2b43168609d9ebd10528b-M43.data.json";